import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import type { TOptions } from "i18next";

type Namespace =
  | "common"
  | "admin"
  | "documents"
  | "notifications"
  | "payments"
  | "statuses";

export function useAppTranslation(defaultNs: Namespace = "common") {
  const { t } = useTranslation();

  const translate = useCallback(
    (
      key: string,
      options?: TOptions,
      ns?: Namespace
    ) => {
      return t(key, {
        ns: ns ?? defaultNs,
        ...options,
      });
    },
    [defaultNs, t]
  );

  return { t: translate };
}